<nav class="header-menu" id="line-container">
  <ng-scrollbar
    track="horizontal"
    appearance="standard"
    position="invertX"
    visibility="hover"
  >
    <div class="header-menu__inner">
      @for (section of sections() | orderBy: 'column_start'; track section) {
        @if (section?.items?.length) {
          <div
            class="header-menu__item"
            dropdown
            #dropdown="bs-dropdown"
            container="body"
            placement="bottom left"
            (mouseenter)="dropdown.show()"
            (mouseleave)="closeDropdown(dropdown)"
          >
            @if (section?.items[0]; as item) {
              <a
                class="header-menu__link"
                [class.no-prevent]="item?.children?.length"
                [title]="section?.items[0]?.page?.short_content || ''"
                [externalLink]="section?.items[0]?.page?.external_url"
                [routerLink]="
                  ['/' + section?.items[0]?.page?.pretty_url] | localize
                "
                [routerLinkActive]="routerLinkActiveClass"
                [routerLinkActiveOptions]="{ exact: false }"
                ><span>
                  {{
                    section?.items[0]?.page?.title ||
                      section?.items[0]?.page?.pretty_url | shorten: 25 : '...'
                  }}
                </span>
                @if (item?.children?.length) {
                  <button
                    type="button"
                    dropdownToggle
                    [attr.aria-label]="
                      !dropdown.isOpen
                        ? ('OPEN_DROPDOWN' | translate)
                        : ('CLOSE_DROPDOWN' | translate)
                    "
                    stopPropagation
                    (click)="$event.preventDefault()"
                  >
                    <fa-icon
                      [icon]="faChevronDown"
                      class="header-chevron"
                      [class.rotate-180]="dropdown.isOpen"
                      [fixedWidth]="true"
                    ></fa-icon>
                  </button>
                }
              </a>
              <!-- Nested links -->
              @if (item?.children?.length) {
                <ul
                  *dropdownMenu
                  class="header-dropdown shadow"
                  role="menu"
                  (mouseenter)="preventClosingDropdown(dropdown)"
                  (mouseleave)="dropdown.hide()"
                >
                  @for (child of item?.children; track child) {
                    <li role="menuitem">
                      <a
                        [title]="child.page?.short_content || ''"
                        [routerLink]="['/' + child.page?.pretty_url] | localize"
                        [routerLinkActive]="routerLinkActiveClass"
                        [routerLinkActiveOptions]="{ exact: false }"
                        [externalLink]="child.page?.external_url"
                        (click)="dropdown.hide()"
                        >{{
                          child.page?.title || child.page?.pretty_url
                            | shorten: 70 : '...'
                        }}</a
                      >
                    </li>
                  }
                </ul>
              }
            }
          </div>
        }
      }
    </div>

    <div class="header-line" id="line-rail">
      <span
        class="header-line__thumb"
        id="line-thumb"
        [ngStyle]="{
          'margin-left.px': thumb.offset,
          'width.px': thumb.width,
          opacity: thumb.opacity,
        }"
      ></span>
    </div>
  </ng-scrollbar>
</nav>
